export const Status = {
  0: {titulo: 'Pendente', class: 'warning', color: '#ff9814'},
  1: {titulo: 'Pago', class: 'success', color: '#00a028'},
  2: {titulo: 'Cancelado por Vencimento', class: 'danger', color: '#FF0000'},
  3: {titulo: 'Cancelado pelo Usuário', class: 'danger', color: '#FF0000'}
}

export const StatusTitle = function (s, t) {
  t = typeof t !== 'undefined' ? t : 'titulo'
  if (typeof Status[s] === 'undefined') {
    return 'Unknow status code'
  }
  return Status[s][t]
}

export const STATUS_PENDENTE = 0
export const STATUS_PAGO = 1
export const STATUS_CANCELADO_POR_VENCIMENTO = 2
export const STATUS_CANCELADO_PELO_USUARIO = 3



// WEBPACK FOOTER //
// ./src/domain/grv/helpers/PreRetiradaStatus.js